import * as FileSaver from "file-saver"
import React, { useRef } from 'react'
import Fade from 'react-reveal/Fade'
import * as XLSX from "xlsx"
// import TariffShiftValueForm from '../../components/TariffShiftValue/TariffShiftValueForm/TariffShiftValueForm'
import TariffShiftValueForm from "../../components/TariffShiftValue/TariffShiftValueForm/TariffShiftValueForm"
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Search from '../../components/UI/Search/Search'
import Modal from '../../components/UI/Modal/Modal'
import Table from "../../components/UI/Table/Table"
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import './TariffShiftValues.css'
import Spinner from "../../components/UI/Spinner/Spinner"
import { Collapse } from "@material-ui/core"

const TariffShiftValues = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [showBatchForm, setShowBatchForm] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [tariffShiftValues, setTariffShiftValues] = React.useState([])
    const [newTariffShiftValuePage, setNewTariffShiftValuePage] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [tariffShiftValue, setTariffShiftValue] = React.useState('')
    const [tariffs, setTariffs] = React.useState([])
    const [tariffId, setTariffId] = React.useState('')
    const [tariffShiftValueId, setTariffShiftValueId] = React.useState('')
    const [shifts, setShifts] = React.useState([])
    const [lockerTypes, setLockerTypes] = React.useState([])
    const [showDetails, setShowDetails] = React.useState(false)
    const [modalContent, setModalContent] = React.useState('')
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })
    const ref = useRef();
    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        var raw1 = JSON.stringify({
            "lockerType": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url1 = 'management/api/v1/lockertypes/getLockerTypes'
        FetchData(raw1, url1).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setLockerTypes(result.lockerTypes)
                }
            })
            .catch(error => setLoading(false))
        var raw = JSON.stringify({
            "shift": {
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/shifts/getShifts'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setShifts(result.shifts)
                }
            })
            .catch(error => setLoading(false))

        var raw = JSON.stringify({
            "zone": {
            },
            "version": "mtpx001"
        })
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "tariff": {
                "description": searchParams.description.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffs/getTariffs'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.tariffs)
                    pushData(newList)
                    setTariffs(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: "شرح",
                align: 'center',
            },
            {
                accessorKey: 'cancelPenaltyPercent',
                header: "درصد کسر مبلغ",
                align: 'center',
            },
            {
                accessorKey: 'fromDate',
                header: "از تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'toDate',
                header: "تا تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'finalize',
                header: "وضعیت رکورد",
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: "وضعیت",
                align: 'center',
            },
        ];
        const buttons = [];
        buttons.push({ id: 1, text: 'مشاهده مقادیر', clicked: showTariffShiftValues });
        buttons.push({ id: 2, text: 'افزودن مقدار', clicked: addTariffShiftValues });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
                cancelPenaltyPercent: d.cancelPenaltyPercent,
                fromDate: d.fromDate,
                toDate: d.toDate,
                finalize: d.finalize != null && d.finalize == '1' ? 'نهایی است' : 'نهایی نیست',
                isActive: d.isActive != null && d.isActive == '1' ? 'فعال است' : 'فعال نیست',
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const toggleNewLockerForm = (event, value) => {
        if (value == false) {
            search();
        }
        setNewTariffShiftValuePage(value)
    }
    const tariffShiftValueChangeState = (event, id) => {
        setTariffShiftValueId(id)
        setModalContent(<div>
            <div className='row justify-content-center'>
                آیا از تغییر وضعیت مطمئن هستید؟
            </div>
            <div className='row justify-content-center mt-4'>
                <Button btnType='Success' clicked={() => tariffShiftValueChangeStateSubmit(id)}>بله</Button>
            </div>
        </div>)
        ref.current.openModal()
    }
    const tariffShiftValueChangeStateSubmit = (id) => {
        var raw = JSON.stringify({
            "tariffShiftValue": {
                "id": id
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffShiftValues/changeTariffShiftValueState'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    ref.current.closeModal()
                    props.showTariffShiftValues(null, props.tariff.id)
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                }
            })
            .catch(error => setLoading(false))
    }

    const editTariffShiftValue = (event, id) => {
        const lckrTp = tariffShiftValues.filter(l => l.id == id)
        if (lckrTp != null && lckrTp.length != 0) {
            setTariffShiftValue(lckrTp[0])
            setEdit(true)
            toggleNewLockerForm(event, true)
        }
    }
    const showTariffShiftValues = (id, data) => {
        setTariffId(id);
        var raw = JSON.stringify({
            "tariffShiftValue": {
                "tariff": {
                    "id": id
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffShiftValues/getTariffShiftValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setTariffShiftValues(result.tariffShiftValues)
                    setShowDetails(true)
                }
            })
            .catch(error => setLoading(false))
    }
    const refreshTariffShiftValues = (event) => {
        var raw = JSON.stringify({
            "tariffShiftValue": {
                "tariff": {
                    "id": tariffId
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffShiftValues/getTariffShiftValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setTariffShiftValues(result.tariffShiftValues)
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                }
            })
            .catch(error => setLoading(false))
        setNewTariffShiftValuePage(false)
    }
    const addTariffShiftValues = (id) => {
        setTariffId(id)
        setTariffShiftValue('')
        setEdit(false)
        toggleNewLockerForm(null, true)
    }
    const editTariffShiftValues = (event, tariffShValueId) => {
        setTariffShiftValueId(tariffShValueId)
        setTariffShiftValue('')
        setEdit(true)
        const tShV = tariffShiftValues.filter(t => t.id === tariffShValueId);
        if (!!tShV && tShV.length > 0) {
            setTariffShiftValue(tShV[0]);
            setShowDetails(false);
            toggleNewLockerForm(event, true)
        }
    }
    const addBatchTariffShiftValues = (event, tariffId) => {
        setTariffId(tariffId)
        setEdit(false)
        toggleNewLockerForm(event, false)
        setShowBatchForm(true)
    }
    const afterCloseModal = (event) => {
    }

    const excelTariffShiftValues = (event, tariffId) => {
        var raw = JSON.stringify({
            "tariffShiftValue": {
                "tariff": {
                    "id": tariffId
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffShiftValues/getTariffShiftValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportValues = []
                    const values = result.tariffShiftValues.map(v => {
                        if (v.isActive == '1') {
                            exportValues.push({
                                'مقدار': v.value,
                                'شناسه تعرفه': tariffId,
                                'شیفت': v.shift != null ? v.shift.id : '',
                                'zone': v.zone != null ? v.zone.id : '',
                                'zone تاریخی': v.calendarZone != null ? v.calendarZone.id : '',
                                "نوع باکس": v.lockerType != null ? v.lockerType.id : ''
                            })
                        }
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportValues);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'Orders' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 hulf-small">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
            {/* <div className="col-10 text-right mt-1 hulf-small">
                <a href={Sample} className="tariff-sample" download>نمونه فایل</a>
            </div> */}
        </div>
    </div>

    return (
        <div>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showDetails}>
                {!showBatchForm && !newTariffShiftValuePage ?
                    <Fade duration={200} left cascade>
                        <Search class="orders-search" form={form} />

                        {rerender ?
                            // <Spinner />
                            <Table hasDetails={false} data={tariffs} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            :
                            <Table hasDetails={false} data={tariffs} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                        }
                    </Fade>
                    :
                    <div>
                        {!showBatchForm ?
                            <TariffShiftValueForm lockerTypes={lockerTypes} shifts={shifts} tariffId={tariffId} edit={edit} tariffShiftValue={edit ? tariffShiftValue : ''} toggleNewLockerForm={toggleNewLockerForm} refreshTariffShiftValues={(event) => refreshTariffShiftValues(event, tariffId)} />
                            : ''}
                    </div>
                }
            </Collapse>
            <Collapse in={showDetails}>
                {showDetails ?
                    <>
                        {!!tariffShiftValues && tariffShiftValues.length > 0 ? tariffShiftValues.map(t => {
                            return (
                                <div className="row justify-content-center w-100 mt-2">
                                    <div className={t.isActive == '1' ? "trf-vls-row" : "deactive-trf-vls-row"}>
                                        <div className="row">
                                            <div className="col-2 hulf-small">
                                                مقدار: {t.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </div>
                                            <div className="col-2 hulf-small">
                                                ساعت شروع رزرو: {t.startTime}
                                            </div>
                                            <div className="col-2 hulf-small">
                                                ساعت پایان رزرو: {t.endTime}
                                            </div>
                                            <div className="col-2 hulf-small">
                                                اختلاف روز: {t.diff} روز
                                            </div>
                                            <div className="col-2 hulf-small">
                                                <Button btnType='General' clicked={(event) => tariffShiftValueChangeState(event, t.id)} >تغییر وضعیت</Button>
                                            </div>
                                            <div className="col-2 hulf-small">
                                                <Button btnType='General' clicked={(event) => editTariffShiftValues(event, t.id)} >ویرایش</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-2 hulf-small">
                                                نوع: {t.lockerType?.description}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                            :
                            <div className="row justify-content-center w-100 ml-0 mr-0">
                                <div className="mt-5 p-4" style={{ width: '50%', backgroundColor: 'white', borderRadius: '9px' }}>
                                    <div className="row justify-content-center w-100 ml-0 mr-0">
                                        مقادیری برای این تعرفه ایجاد نشده است
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row justify-content-center w-100 ml-0 mr-0 mt-4">
                            <div className="col-6" style={{ textAlign: 'center' }}>
                                <Button btnType='General' clicked={() => setShowDetails(false)} >برگشت</Button>
                            </div>
                        </div>
                    </>
                    : ''}
            </Collapse>
            {/* {showBatchForm ?
                <BatchUploadTariffShiftValue showTariffShiftValues={showTariffShiftValues} toggleShowBatchForm={toggleShowBatchForm} tariffId={tariffId} />
                : ''} */}
            <Modal
                content={modalContent}
                ref={ref}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </div>
    )
}

export default TariffShiftValues